import { captureExceptionWithContext, captureMessageWithContext } from "@/sentry";
import { useAppStore } from "@/stores";

/**
 * Wrapper for server communication that handles connection state and errors
 * @param {Function} fn - Function to execute with session
 * @param {Array} argumentsArray - Arguments to pass to the function
 * @returns {*} Result of the function call
 */
export function runFnToCall(fn, argumentsArray = []) {
  const appStore = useAppStore();
  if (appStore.wsconnection.isOpen) {
    const res = fn(appStore.wsconnection.session, ...argumentsArray);
    if (!res || !res.catch) {
      return res;
    }
    return res.catch((e) => {
      void captureExceptionWithContext(e, { fn, argumentsArray });
    });
  } else {
    void captureMessageWithContext("Connection interrupted, try to reload the page");
  }
}
